/**
 * For a feature that was RC-staff only and is now sold through the Feature
 * Matrix (Trade Feed, the Deals tabs — Alex, 2026-10-27). Mirrors the backend
 * `feature.open` gate (EnsureOpenedFeature): master admins always; a merchant
 * only when the store is in ENFORCE mode and the matrix grants it. DAO Watches
 * staff (a seat on a DAO store — the backend's `platform_staff`) always get
 * them, like master admins (Alex, 2026-10-30).
 *
 * FAIL-CLOSED for merchants, unlike hasFeature/useEntitlement — with
 * enforcement off every store would otherwise get these.
 *
 * `entitlements` is the EntitlementsContext value (useEntitlements()).
 */
export function canUseOpenedFeature(user, { mode, featureState, platformStaff }, key) {
  if (!user) return false;
  if (user.is_master_admin || platformStaff) return true;
  return mode === "enforce" && featureState(key) === "on";
}
